import { useTheme } from '@mui/material/styles';
import red from '@mui/material/colors/red';

const shadowBorder = ' 3px 0px 0px 1px inset';

const rowStylePlans = (selectedRow) => (record) => {
  const theme = useTheme();
  let style = {};
  if (!record) {
    return style;
  }
  style = {};
  if (selectedRow && selectedRow === record.id) {
    style = {
      ...style,
      backgroundColor: theme.palette.action.selected,
    };
  }
  if (record.archivado)
    return {
      ...style,
      // borderLeftColor: red[500],
      // borderLeftWidth: 3,
      // borderLeftStyle: 'solid',
      borderTopLeftRadius: '15px 10px',
      borderBottomLeftRadius: '15px 10px',
      boxShadow: red[500] + shadowBorder
    };
  return style;
};

export default rowStylePlans;